import axios from "axios";
import Head from "../components/NavBar/Head";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "react-bootstrap/Card";
import {
  Col,
  Form,
  InputGroup,
  Modal,
  Button,
  Row,
  Image,
} from "react-bootstrap";
import Modals from "../components/Modal";
import ReactDOMServer from "react-dom/server";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import { SET_REFRESH_DATA_TABLE } from "../store/Theme/ThemeActionTypes";
import DataTables from "../components/DataTables";
import { BsEye, BsPen, BsTrash3 } from "react-icons/bs";
import { FETCH_MEDIA_SUCCESS } from "../store/Media/MediaActionTypes";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { BiImage } from "react-icons/bi";
import MediaGrid from "../components/MediaGrid";

const Media = () => {
  const [media, setMedia] = useState(null);
  const [showPopup, setShowPopup] = useState({ is: false, msg: "" });
  const [viewMedia, setViewMedia] = useState(false);
  const { userInfo } = useSelector((state) => state?.userInfo);
  const dispatch = useDispatch();
  const formatDate = userInfo?.account_preferences?.date_formate;
  const [viewAsGrid, setViewAsGrid] = useState(false);
  const columns = [
    {
      data: "id",
      class: "d-none",
    },
    {
      data: "url",
      class: "text-left align-middle",
      width: "80px",
      height: "80px",
      title: "File",
      render: function (data, type, row) {
        return ReactDOMServer.renderToString(
          <div class="text-right">
            <Image
              src={`${process.env.REACT_APP_API_BASE_URL?.replace(
                "/api",
                "/public/uploads"
              )}${row?.url}`}
              style={{ cursor: "pointer", width: "80px", height: "80px" }}
              class="img-thumbnail media-image"
              data-url={JSON.stringify(row?.url)}
            />
          </div>
        );
      },
    },

    {
      data: "title",
      class: "text-left align-middle",
      title: "Title",
    },
    {
      data: "extension",
      class: "text-left align-middle",
      title: "File Type",
    },

    {
      data: "created_at",
      class: "text-left align-middle",
      title: "Created On",
      render: function (data, type, row) {
        if (row["created_at"] === null) return "-";
        return `${moment(row["created_at"] || row["updated_at"]).format(
          `${
            formatDate === null || formatDate === undefined
              ? "DD MMM, YYYY"
              : formatDate
          }`
        )}`;
      },
    },

    {
      data: null,
      class: "text-left align-middle  ",
      title: "Actions",
      width: "150px",
      orderable: false,
      render: function (data, type, row) {
        return ReactDOMServer.renderToString(
          <div className="text-right">
            <Button
              data-tooltip-id="my-tooltip"
              data-tooltip-content="View"
              variant="light"
              size="sm"
              className="btn-icon mx-1"
              data-id={JSON.stringify(row?.url)}
              data-action="handleViewMedia"
            >
              <BsEye size={17} />
            </Button>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    const handleImageClick = (event) => {
      const target = event.target;
      if (target.classList.contains("media-image")) {
        const mediaUrl = target.getAttribute("data-url");
        if (mediaUrl) {
          handleViewMedia(mediaUrl);
        }
      }
    };

    document.addEventListener("click", handleImageClick);

    return () => {
      document.removeEventListener("click", handleImageClick);
    };
  }, []);

  const handleViewMedia = (url) => {
    setViewMedia(
      `${process.env.REACT_APP_API_BASE_URL?.replace(
        "/api",
        "/public/uploads"
      )}${url?.replace(/^"|"$/g, "")}`
    );
  };

  const handlePopupClose = () => {
    setShowPopup({
      ...showPopup,
      is: false,
      msg: "",
    });
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = [...e.dataTransfer.files];
    const validFiles = droppedFiles.filter((file) =>
      ["image/jpeg", "image/png", "image/jpg"].includes(file.type)
    );
    // uploadImage([...e.dataTransfer.files]);
    if (validFiles.length === 0) {
      setShowPopup({
        ...showPopup,
        is: true,
        msg: "File type not supported",
      });
      return;
    }
    uploadImage(validFiles);
  };

  const allowDrop = (e) => {
    e.preventDefault();
  };
  const uploadImage = async (droppedFiles) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_UPLOAD_MEDIA}`,
        { url: droppedFiles },
        {
          headers: {
            "Content-Type": "multipart/form-data", // Set proper content type
            Authorization: `Bearer ${userInfo?.token}`,
          },
        }
      );
      // Clear form fields after successful upload
      toast.success("Media uploaded successfully", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      if (viewAsGrid) {
        handleSwitchToGrid("reload");
      } else {
        dispatch({ type: SET_REFRESH_DATA_TABLE, data: Math.random() });
      }
    } catch (error) {
      setShowPopup({
        ...showPopup,
        is: true,
        msg: "Error uploading media",
      });
    }
  };

  const handleSwitchToGrid = (type) => {
    if (type === "reload") {
      setViewAsGrid(false);
      setTimeout(() => {
        setViewAsGrid(true);
      }, 100);
    } else {
      setViewAsGrid(true);
    }
  };

  if (viewAsGrid)
    return (
      <>
        <MediaGrid
          viewAsGrid={viewAsGrid}
          setViewAsGrid={setViewAsGrid}
          onDrop={handleDrop}
          onDragOver={allowDrop}
        />
        <ToastContainer style={{ top: "60px" }} />
      </>
    );
  return (
    <>
      <h3 className="m-0">Media</h3>
      <div
        className="drag-drop-area mt-4"
        style={{
          border: 0,
        }}
      >
        <Row className="m-0 g-2">
          <Col xs={12}>
            <Card className="border-0 shadow-sm">
              <Card.Body>
                <div
                  className="m-0 mb-3 rounded-1 d-flex flex-column align-items-center justify-content-center"
                  onDrop={handleDrop}
                  onDragOver={allowDrop}
                  style={{
                    borderWidth: "1px",
                    borderStyle: "dotted",
                    borderColor: "gray",
                  }}
                >
                  <BiImage
                    className="text-gray text-muted"
                    style={{ fontSize: "3rem" }}
                  />
                  <small className="text-muted" style={{ fontSize: "1rem" }}>
                    Drag and Drop Files Here
                  </small>
                </div>

                <DataTables
                  url={`${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_FETCH_MEDIA}`}
                  columns={columns}
                  defaultSortedColumnIndex={0}
                  handleViewMedia={handleViewMedia}
                  dispatchCallType={FETCH_MEDIA_SUCCESS}
                  handleImportModal={handleSwitchToGrid}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>{" "}
      <Modal
        centered
        show={viewMedia !== false}
        onHide={() => setViewMedia(false)}
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title style={{ fontSize: "18px" }}>Media</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          <Image src={`${viewMedia}`} alt="img" class="img-thumbnail " />
        </Modal.Body>
      </Modal>
      <ToastContainer style={{ top: "60px" }} />
      <Modals showModal={showPopup} handleClose={handlePopupClose} />
      <ReactTooltip id="my-tooltip" />
    </>
  );
};

export default Media;
